import AlertScreens from './alert-screens';
import Banners from './banners';
import Cards from './cards';
import Layout from './layout';
import Lib from './lib';
import Order from './order';
import Print from './print';

export default {
  AlertScreens,
  Banners,
  Cards,
  Layout,
  Lib,
  Order,
  Print,
};
